import "react-toastify/dist/ReactToastify.css";
import { Avatar, Box } from "@mui/material";


const MainChatPage = ({
  mainPageCaptions,
  botIconImg
}) => {
  const tc_icon = require("../../../images/"+botIconImg);
  return (
    <>
      <div>
        {/* Centered bot Avatar */}
        <center>
          <Avatar sx={{ width: 50, height: 50 }}>
            <img alt="" src={tc_icon} width="50" />
          </Avatar>
        </center>

        {/* Main Caption Text */}
        <Box className="mainCaptionTextBox">
          <p
            className="h6Generic"
            dangerouslySetInnerHTML={{
              __html: mainPageCaptions,
            }}
          ></p>
        </Box>
        <br />
      </div>
    </>
  );
};

export default MainChatPage;
